var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF526C"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDCBF"
    },
    d: "M419.352,371.063c-4.263,11.776-10.156,22.956-17.408,33.301 c-38.201,54.502-105.388,74.198-164.624,56.884c-23.552-6.875-45.861-19.613-64.575-38.327l-56.55-56.55l-6.28-6.029l-37.731-36.227 c-6.625,0-12.8-1.881-18.045-5.13c-9.77-6.04-16.28-16.865-16.28-29.194c0-12.34,6.51-23.165,16.28-29.205 c5.245-3.239,11.421-5.12,18.045-5.12c-6.625,0-12.8-1.881-18.045-5.13c-9.77-6.04-16.28-16.854-16.28-29.184 c0-12.34,6.51-23.155,16.28-29.194c5.245-3.25,11.421-5.13,18.045-5.13v-40.385c-6.625,0-12.8-1.86-18.045-5.11 c-9.77-6.05-16.28-16.865-16.28-29.194c0-12.34,6.51-23.165,16.28-29.205c5.245-3.239,11.421-5.12,18.045-5.12l219.314,106.339 l8.495,4.106l9.561,4.639c0.721-8.589,2.142-17.168,4.263-25.684c2.8-11.254,10.355-20.072,20.02-24.795 c7.701-3.803,16.75-5.005,25.746-2.769c20.25,5.026,32.59,25.527,27.564,45.767c-5.632,22.643-2.1,46.132,9.958,66.111 C397.106,251.527,439.874,314.116,419.352,371.063z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBB8D"
    },
    d: "M237.32,461.248c-23.552-6.875-45.861-19.613-64.575-38.327l-56.55-56.55l-6.28-6.029l98.022,20.219 C148.347,380.561,196.245,435.711,237.32,461.248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBB8D"
    },
    d: "M337.693,299.06c-1.609,0.969-3.376,1.439-5.127,1.439c-3.376,0-6.68-1.723-8.546-4.843 c-18.9-31.377-27.276-67.085-24.256-103.262c0.015-0.698,0.071-2.109,0.228-4.13l9.558,4.629c0.726-8.589,2.15-17.163,4.273-25.68 c2.792-11.251,10.355-20.068,20.012-24.798c-13.659,26.321-14.129,50.278-14.129,50.563l-0.043,0.769 c-0.114,1.31-0.2,2.621-0.271,3.917c-1.553,25.552,3.361,50.762,14.3,73.878c2.221,4.7,4.686,9.315,7.406,13.83 C343.932,290.101,342.422,296.226,337.693,299.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBB8D"
    },
    d: "M291.502,184.148V349.88c0,16.949-16.052,30.679-35.879,30.679H130.385l-14.187-14.187 l-44.011-42.259c-6.623,0-12.804-1.88-18.045-5.127l0.367-0.493c12.81-17.221,12.661-40.846-0.367-57.904l0,0 c5.241-3.248,11.423-5.127,18.045-5.127c-6.623,0-12.804-1.88-18.045-5.127l2.331-2.903c11.641-14.495,12.246-34.955,1.482-50.111 l-3.813-5.368c5.241-3.248,11.423-5.127,18.045-5.127v-40.379c-6.623,0-12.804-1.866-18.045-5.114l5.967-10.067 c7.401-12.484,7.103-28.082-0.768-40.276l-5.199-8.054c5.241-3.248,11.423-5.127,18.045-5.127L291.502,184.148z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#374266"
    },
    d: "M72.187,150.285V64.323c0-16.945,16.062-30.689,35.879-30.689h165.603 c19.818,0,35.879,13.744,35.879,30.689V349.88c0,16.945-16.062,30.679-35.879,30.679H108.065c-19.816,0-35.879-13.734-35.879-30.679 v-18.965C72.187,330.915,72.187,150.285,72.187,150.285z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.216,
    y: 86.507,
    style: {
      fill: "#F2F2F7"
    },
    width: 201.3,
    height: 241.183
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#65A3E6"
    },
    d: "M488.911,362.39c-22.329,48.828-59.57,89.412-105.9,115.931 c-24.377,13.96-51.273,24.022-79.83,29.341l-33.698-33.698l165.501-165.501L488.911,362.39z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495B94"
    },
    d: "M221.517,71.682h-61.301c-4.424,0-8.011-3.586-8.011-8.011l0,0c0-4.424,3.586-8.011,8.011-8.011 h61.301c4.424,0,8.011,3.586,8.011,8.011l0,0C229.529,68.096,225.941,71.682,221.517,71.682z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#495B94"
    },
    cx: 190.872,
    cy: 354.126,
    r: 15.114
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B79CF"
    },
    d: "M383.01,478.322c-24.377,13.96-51.273,24.022-79.83,29.341l-33.698-33.698l54.585-54.585 L383.01,478.322z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 130.414,
    y: 146.641,
    style: {
      fill: "#495B94"
    },
    width: 13.537,
    height: 13.538
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.414,
    y: 254.015,
    style: {
      fill: "#495B94"
    },
    width: 13.537,
    height: 13.537
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495B94"
    },
    d: "M212.73,121.583v63.652h63.651v-63.652H212.73z M260.768,169.621h-32.426v-32.426h32.426V169.621z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.787,
    y: 146.641,
    style: {
      fill: "#495B94"
    },
    width: 13.538,
    height: 13.537
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#495B94"
    },
    points: "197.635,227.402 197.635,213.866 184.098,213.866 184.098,227.402 184.098,240.939  197.635,240.939 197.635,241.31 197.635,254.846 211.173,254.846 211.173,241.31 211.173,227.772 197.635,227.772  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#495B94"
    },
    points: "249.306,196.644 249.306,210.181 262.844,210.181 276.381,210.181 276.381,196.644  262.844,196.644  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.466,
    y: 255.122,
    style: {
      fill: "#495B94"
    },
    width: 13.537,
    height: 13.537
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.559,
    y: 200.328,
    style: {
      fill: "#495B94"
    },
    width: 13.538,
    height: 13.538
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.562,
    y: 225.886,
    style: {
      fill: "#495B94"
    },
    width: 13.538,
    height: 13.538
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.562,
    y: 239.417,
    style: {
      fill: "#495B94"
    },
    width: 13.538,
    height: 13.538
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.405,
    y: 265.54,
    style: {
      fill: "#495B94"
    },
    width: 13.538,
    height: 13.538
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.405,
    y: 279.071,
    style: {
      fill: "#495B94"
    },
    width: 13.538,
    height: 13.538
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495B94"
    },
    d: "M262.559,251.998h-13.538h-13.538v13.538v13.538v13.538h13.538h13.538h13.538v-13.538v-13.538 v-13.538H262.559z M262.559,279.073h-13.538v-13.538h13.538V279.073z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#495B94"
    },
    points: "230.418,197.955 216.88,197.955 203.343,197.955 203.343,211.492 216.88,211.492  216.88,225.029 230.418,225.029 230.418,238.567 243.954,238.567 243.954,225.029 243.954,211.492 230.418,211.492  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495B94"
    },
    d: "M136.579,200.328v13.538h13.537v-13.538v-15.094h18.889v-63.652h-63.651v63.652h31.226V200.328z  M120.967,137.195h32.426v32.426h-32.426V137.195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#495B94"
    },
    d: "M118.891,200.328h-13.537v28.631v5.77v57.882h63.651v-63.652h-50.114V200.328z M120.966,244.572 h32.426v32.426h-32.426C120.966,276.998,120.966,244.572,120.966,244.572z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#495B94"
    },
    points: "197.635,173.714 197.635,160.178 197.635,146.641 184.098,146.641 184.098,160.178  184.098,173.714 184.098,187.251 197.635,187.251  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.7f677c7b39ba448bb8b110f78cb9f8ac.svg";
export { ForwardRef as ReactComponent };